import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 批量新增救援队伍人员
export function batchSumbit(data) {
    return request({
        baseURL,
        url: '/emergencyTeamPerson/batchSumbit',
        method: 'post',
        data
    })
}
// 新增/编辑救援队伍人员
export function submit(data) {
    return request({
        baseURL,
        url: '/emergencyTeamPerson/submit',
        method: 'post',
        data
    })
}
//查询救援队伍人员列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyTeamPerson/list',
        method: 'get',
        params
    })
}
//查询救援队伍人员
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyTeamPerson/detail?id=' + id,
        method: 'get',
    })
}
//删除救援队伍人员
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyTeamPerson/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}